import PartnerPageTable from "./PartnerPageTable";
export default function PartnerClientsPage() { return <PartnerPageTable title="Հաճախորդների ցանկ" subtitle="Կառավարեք ձեր ներգրաված հաճախորդներին" rows={[]} />; }
